import { Component, Input, OnChanges, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DistributorService } from '../../../../services/distributor.service';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { StihlDistributorDTO, StihlDistributorLogoPostDTO } from 'src/app/models/stihl-distributor-dto';
import { Select2Data } from 'ng-select2-component';
import { StihlDistributorLogoDTO } from 'src/app/models/stihl-campaign-dto';
import { SharedService } from 'src/app/services/shared.service';
import { Helpers } from 'src/app/helpers/helpers';

@Component({
  selector: 'distributor-logotipo',
  templateUrl: './distributor-logotipo.component.html'
})

export class CommonDistributorLogotipoComponent implements OnInit, OnChanges {

  @Input() idDistributor: string;
  @Input() editable: boolean;
  @Input() inTab: boolean;

  model: StihlDistributorDTO;
  dataform: FormGroup;
  submitted = 0;
  addingLogo = false;
  public campaignmediaTypes: Select2Data;
  files: File[] = [];


  constructor(private sharedService: SharedService,
    private helper: Helpers,
    private toastr: ToastrService,
    private distributorService: DistributorService) {

  }

  ngOnInit() {
    this.dataform = new FormGroup({
      IdCampaignMaterialMediaType: new FormControl(null, [Validators.required]),
      Description: new FormControl('')
    });
  }

  ngOnChanges() {
    if (this.idDistributor) {
      this.getDistributor();
    }
  }

  loadData() {
    this.sharedService.getCampaignMaterialMediaType().subscribe(resp => {
      this.campaignmediaTypes = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }

  getDistributor() {
    this.distributorService.get(this.idDistributor).subscribe(resp => {
      this.model = resp;

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }

  onFileSelect(event) {
    if (this.files.length > 0) {
      this.files.splice(0, 1);
    }
    this.files.push(...event.addedFiles);
  }

  onRemoveFile(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  AddLogo() {
    this.addingLogo = true;
    this.loadData();
  }

  CancelAddLogo() {
    this.addingLogo = false;
    this.campaignmediaTypes = [];
  }

  SaveLogo() {

    this.submitted = 1;

    if (this.dataform.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar Alteração/Logótipo',
        text: 'Deve selecionar um meio para a Alteração/Logótipo'
      });
      return;
    }

    let postModel: StihlDistributorLogoPostDTO = this.dataform.value;
    postModel.IdDistributor = this.model.IdDistributor;

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…'
    });
    Swal.showLoading();

    if (this.files.length > 0)
      postModel.FileLogo = this.files[0];

    var data = this.helper.getFormData(postModel);

    if (this.files.length > 0) {
      this.postData(data);
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar Alteração/Logótipo',
        text: 'Deve anexar uma imagem para a Alteração/Logótipo'
      });
    }
  }

  postData(data: FormData) {
    this.distributorService.insertDistributorLogo(data).subscribe(resp => {
      this.toastr.success("A Alteração/Logótipo foi criado com sucesso");
      this.addingLogo = false;
      Swal.close();
      this.getDistributor();
      this.campaignmediaTypes = [];
      this.dataform.controls["IdCampaignMaterialMediaType"].setValue(null);
      this.dataform.controls["Description"].setValue(null);
      this.files = [];
    }, (err) => {

      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar',
        text: 'Ocorreu um erro'
      });
    });
  }

  DeleteLogo(idLogo) {

    Swal.fire({
      title: 'Deseja remover esta alteração/Logótipo?',
      text: "Não poderá voltar a utilizar esta alteração/Logótipo nas campanhas de publicidade",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      allowOutsideClick: false,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.distributorService.deleteLogo(idLogo).subscribe((resp) => {
          this.toastr.success("A Alteração/Logótipo foi removido com sucesso");
          this.getDistributor();
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao remover a alteração/Logótipo',
            text: 'Ocorreu um erro'
          });
        });
      }
    })
  }
}

